import Cookies from 'js-cookie'

const initAnnouncementBar = () => {
	const announcementBar = document.querySelector('#announcement-bar');

	if ( isBarClosed() ) {
		return;
	}

	setBannerHeight( announcementBar );
}

const isBarClosed = () => {
	return Cookies.get('announcement_closed') === 'true' ?? false;
}

const setBannerHeight = ( banner ) => {
	const site = document.querySelector('#page');

	site.style = `--banner-height: ${banner.offsetHeight}px`;
}

const closeInit = () => {
	const closeButton = document.querySelector('.b-v4-block-container-banner-x');
	if (!closeButton) {
		return;
	}
	closeButton.addEventListener('click', (e) => {
		Cookies.set('announcement_closed', true, { expires: 30 });
		e.target.closest('[data-banner-container]').classList.toggle('active');
		const site = document.querySelector('#page');
		site.style = `--banner-height: 0px`;
	})
}

const updateBarHeight = () => {
	setTimeout(() => {
		const announcementBar = document.querySelector('#announcement-bar');
		setBannerHeight(announcementBar);
	}, 200 );
}

window.addEventListener('DOMContentLoaded', () => {
	initAnnouncementBar();
	closeInit();
});

window.addEventListener('resize', () => {
	updateBarHeight()
})